import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

const drawerWidth = 539;

export default (theme: APTheme) => createStyles({
    form: {
        width: "100%"
    },
    input: {
        display: 'none',
    },
    poiBulletPoints: {
        listStyle: "none",
        margin: "15px 0",
        boxShadow: "none",
        zIndex: 3,

        "&:last-of-type": {
            marginBottom: 0
        }
    },
    poiBullet: {
        fontSize: 16,
        fontFamily: "CircularStd",
        fontWeight: 500,
        lineHeight: "30px",
        height: 52
    },
    poiBulletImage: {
        width: 52,
        height: 52,
        margin: "0 16px 0 0"
    },
    poiLabel: {
        position: "absolute",
        marginTop: 10
    },
    textButton: {
        position: "absolute",
        marginTop: 18,
        minWidth: 'auto',
        padding: 0,
        fontSize: 15,
        letterSpacing: '-0.5px',
        zIndex: 4,
        "&:hover, &:active": {
            backgroundColor: 'transparent'
        }
    },
    textButtonOpen: {
        right: 76
    },
    textButtonClosed: {
        right: 46
    },
    hide: {
        display: "none",
    },
    show: {
        display: "block",
    },
    loadingBar: {
        width: "100%"
    },
    uploadButton: {
        border: "1px #a4a4a4 dashed",
        width: 220,
        background: "#FFF",
        color: "#2d91e9",
        "&:hover, &:active": {
            background: "#FFF",
            border: "1px #2d91e9 solid",
        }
    },
    fileInput: {
        display: "none",
    },
    fileInputLabel: {
        width: "100%",
        padding: "5px 0",
        borderRadius: 35
    },
    blueTick: {
        position: "absolute",
        top: 22,
        right: 15,
        width: 26,
        height: 26
    },
    invalidFileTypes: {
        display: "block",
        padding: "14px 15px",
        margin: "0 0 10px",
        height: 20,
        width: 490,
        background: "#fbfbfb"
    },
    errorIcon: {
        display: "inline-block",
        marginRight: 10
    },
    errorMessage: {
        fontSize: 16,
        fontFamily: "CircularStd",
        color: "#4a4a4A",
        position: "relative",
        top: -6
    },
    withToolTip: {
        marginTop: 25,
    },
    withoutToolTip: {

    },
    mobileHeading: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
            display: 'flex',
            fontSize: '2.6rem',
            justifyContent: 'center'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '2rem'
        }
    },
    twoFormsContinue: {
        width: "100%"
    },
    formButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column-reverse'
        }
    },
    formButtonsLeft: {

    },
    formButtonsRight: {
        justifyContent: 'flex-end'
    },
    formButton: {
        display: "flex",
        width: 200,
        marginBottom: 16,
        [theme.breakpoints.down('lg')]: {
            float: "right",
            width: 200
        },
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    },
    centreButtons: {
        textAlign: "center"
    },
    helpIcon: {
        width: 22,
        height: 22,
        marginTop: 1
    },
    panelLinkExpanded: {
        right: 75
    },
    panelLinkClosed: {

    },
    skipLink: {
        fontFamily: "CircularStd",
        color: "#2D91E9",
        display: "inline-flex",
        marginTop: "-4px",
        float: "right",
        backgroundColor: "transparent",
        "&:hover, &:active": {
            backgroundColor: 'transparent'
        },
        '@media(max-width: 768px)': {
            float: "none"
        }
    },
    panelLink: {
        margin: "33px 15px 0 0"
    },
    formSection: {
        padding: 30,
        marginBottom: 0,
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
        [theme.breakpoints.down('md')]: {
            padding: 20
        },
    },
    formSectionContent: {
        marginTop: 20
    },
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex-grid',
        justifyContent: 'space-between',
        [theme.breakpoints.down('lg')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
            marginBottom: 30
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: 82
        },
    },
    formSectionSubHeading: {
        fontSize: 16,
        lineHeight: "22px",
        marginBottom: 10
    },
    oneSectionHeader: {
        width: "100%",
        display: "block",
        margin: 0,
    },
    twoSectionsHeader: {
        width: "100%",
        display: "block",
        marginBottom: 20,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        position: "absolute",
        right: 0,
        top: 0,
        height: 2000,
        zIndex: 5
    },
    drawerOpen: {
        boxShadow: "-15px 0 15px 0 rgba(0, 0, 0, 0.08)",
        background: "#fbfbfb",
        padding: "30px 65px",
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: 539,
        [theme.breakpoints.up("xs")]: {
            width: 539,
        },
    },
    toolTip: {
        position: "absolute",
        margin: "22px 0 0",
        right: "40px",
        [theme.breakpoints.up("md")]: {
            right: "50px"
        },
    },

    docUploadContainer: {
        display: "flex",
        width: "100%",
        maxWidth: 1110,
        padding: '34px 35px',
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    docUploadInnerSection: {
        width: '100%',
    },
    docUploadHeader: {
        width: "100%",
    },
    docUploadSectionHeading: {
        fontWeight: 500,
        marginBottom: 24,
        display: "inline-flex",
        [theme.breakpoints.down('lg')]: {
            display: "inline-block",
        },
    },
    docUploaderContainer: {
        display: 'grid',
        gridTemplateColumns: '48.5% 48.5%',
        gridColumnGap: '3%',
        '@media(max-width: 768px)': {
            display: 'block',
        }
    },
    viewContainer: {
        marginBottom: '60px'
    },
    completeViewContainer: {
        width: '870px',
    },
    formHeader: {
        width: "100%",
        display: "block",
        // height: 30,
        marginBottom: '30px',
    }
});